var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4999 21.3333C22.6044 21.3333 23.4999 20.4378 23.4999 19.3333C23.4999 18.2287 22.6044 17.3333 21.4999 17.3333C20.3953 17.3333 19.4999 18.2287 19.4999 19.3333C19.4999 20.4378 20.3953 21.3333 21.4999 21.3333Z",
    fill: "#2BA168"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1669 19.3333C14.1669 20.4378 13.2714 21.3333 12.1669 21.3333C11.0623 21.3333 10.1669 20.4378 10.1669 19.3333C10.1669 18.2287 11.0623 17.3333 12.1669 17.3333C13.2714 17.3333 14.1669 18.2287 14.1669 19.3333Z",
    fill: "#2BA168"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45333 6.05217C6.0375 6.36907 5.83337 6.87054 5.83337 7.39336V24C5.83337 25.1046 6.7288 26 7.83337 26L10.8333 26L9.54038 27.2929C8.91042 27.9229 9.35658 29 10.2475 29H10.4191C10.6843 29 10.9386 28.8946 11.1262 28.7071L13.8333 26H19.8333L22.5404 28.7071C22.7279 28.8946 22.9823 29 23.2475 29H23.4191C24.31 29 24.7561 27.9229 24.1262 27.2929L22.8333 26L25.8334 26C26.9379 26 27.8334 25.1046 27.8334 24V7.39336C27.8334 6.87054 27.6293 6.36907 27.2134 6.05217C25.9087 5.05782 22.5214 3 16.8334 3C11.1454 3 7.75808 5.05782 6.45333 6.05217ZM17.8334 9H25.8334V14H17.8334V9ZM7.83337 23L7.83337 16H25.8334V23C25.8334 23.5523 25.3857 24 24.8334 24L8.83337 24C8.28109 24 7.83337 23.5523 7.83337 23ZM15.8334 14H7.83337V9H15.8334V14ZM25.0363 7H8.63046C10.1086 6.13095 12.8032 5 16.8334 5C20.8636 5 23.5581 6.13095 25.0363 7Z",
    fill: "#2BA168"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.689ed92e6ced3d9b2f1b49380ff6ff7d.svg";
export { ForwardRef as ReactComponent };